import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import QubFileBundle from './FileBundle';

class QubFileGroup {
    constructor({
        description,
        bundles = [],
        lblComments,
        lblDateFrom,
        lblDateTo,
        lblIssuedAt,
        lblIssuedBy,
        lblNumber,
        lkCommon,
        max,
        templates,
        formFields,
        id
    }) {
        this.description = description;
        this.bundles = []; // bundles.map((bundle) => new QubFileBundle(bundle)) ?? [];
        this.lblComments = lblComments;
        this.lblDateFrom = lblDateFrom;
        this.lblDateTo = lblDateTo;
        this.lblIssuedAt = lblIssuedAt;
        this.lblIssuedBy = lblIssuedBy;
        this.lblNumber = lblNumber;
        this.lkCommon = lkCommon;
        this.bundleValidation = { max: max || Infinity };
        this.templates = templates;
        this.formFields = formFields;
        this.id = id;
    }

    async initializeBundles(bundles) {
        this.bundles = await Promise.all(bundles.map(async (bundle) => QubFileBundle.create(bundle)));
    }

    addBundle(bundle) {
        if (isNil(this.bundleValidation.max)) {
            this.bundles.push(bundle);
            return;
        }
        if (this.bundles.length < this.bundleValidation.max) {
            this.bundles.push(bundle);
        }
    }

    removeBundle(id) {
        this.bundles = this.bundles.filter((bundle) => bundle.id !== id);
    }

    getBundle(id) {
        return this.bundles.find((bundle) => bundle.id === id);
    }

    addFile(file, bundleId) {
        this.bundles.forEach((bundle) => {
            if (bundle.id === bundleId) {
                bundle.addFile(file);
            }
        });
    }

    getFile(id) {
        let bundle;
        // eslint-disable-next-line no-restricted-syntax
        for (bundle of this.bundles) {
            const file = bundle.getFile(id);
            if (!isNil(file)) {
                return file;
            }
        }
        return undefined;
    }

    removeFile(id) {
        this.bundles.map((bundle) => {
            bundle.removeFile(id);
            return bundle;
        });
    }

    static async create(params) {
        const instance = new QubFileGroup(params);
        await instance.initializeBundles(params.bundles ?? []);
        return instance;
    }
}

QubFileGroup.PropTypes = {
    description: PropTypes.string,
    bundles: PropTypes.arrayOf(PropTypes.instanceOf(QubFileBundle)),
    lblComments: PropTypes.string,
    lblDateFrom: PropTypes.string,
    lblDateTo: PropTypes.string,
    lblIssuedAt: PropTypes.string,
    lblIssuedBy: PropTypes.string,
    lblNumber: PropTypes.string,
    lkCommon: PropTypes.object,
    bundleValidation: PropTypes.object,
    templates: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.number
};

export default QubFileGroup;
